import { useState, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { useCreateOrganization } from '@/hooks/organization/use-create-organization';

export function CreateOrganizationPage() {
  const [searchParams] = useSearchParams();
  const orgCreateToken = searchParams.get('orgCreateToken') ?? '';
  const navigate = useNavigate();
  const [orgName, setOrgName] = useState<string>('');

  // TODO: Implement toast error to show user message based on what the hook responds with.
  // https://linear.app/onchainden/issue/DEN-60/toast-errors
  const onError = () => {
    console.error('An error has occurred during organization creation');
  };
  const { create, isLoading } = useCreateOrganization({ onError });

  const isDisabled = useMemo(() => {
    return !orgCreateToken || !orgName.trim() || isLoading;
  }, [orgCreateToken, orgName, isLoading]);

  const handleCreate = async () => {
    await create({ token: orgCreateToken, name: orgName.trim() });
    navigate('/register-device', { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-white">
      <div className="w-full max-w-md space-y-6">
        <div>
          <h1 className="text-xl mb-2">
            What do you want to name your organization?
          </h1>
        </div>
        <div className="space-y-2">
          <Input
            id="orgName"
            value={orgName}
            placeholder="Organization name"
            onChange={(e) => setOrgName(e.target.value)}
          />
        </div>

        <Button className="w-full" onClick={handleCreate} disabled={isDisabled}>
          {isLoading ? 'Creating...' : 'Create organization'}
        </Button>
      </div>
    </div>
  );
}
